import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
  providedIn: 'root'
})

export class SettingDataService {
  constructor(private dataProvider: DataService) {
  }

  getCurrency(): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCurrency).toPromise();
  }
  async GetSettings(): Promise<GenericResponse<any>> {
    return await this.dataProvider.Get<any>(Urls.GetSettings).toPromise();
  }
  async getCountry(): Promise<GenericResponse<any>> {
    return await this.dataProvider.Get<any>(Urls.GetCountryWithCode).toPromise();
  }
  getBrandList(): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<any>(Urls.GetBrands).toPromise();
  }
  getFieldConfiguration(screenName: string): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<any>(Urls.GetFieldConfiguration, screenName).toPromise();
  }

}
